import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=b252d0ae&scoped=true&"
import script from "./RadioInput.vue?vue&type=script&lang=js&"
export * from "./RadioInput.vue?vue&type=script&lang=js&"
import style0 from "./RadioInput.vue?vue&type=style&index=0&id=b252d0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b252d0ae",
  null
  
)

export default component.exports